import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import ProductCards from "../modules/ProductCards";

export default function CollectionProductsList({ data }) {
  const collectionHandle = data.collectionHandle;
  const collectionData = useStaticQuery(collectionProductsQuery);
  const collection = collectionData.allShopifyCollection.edges.find((edge) => {
    return edge.node.handle === collectionHandle;
  });

  if (!collection) {
    return <></>;
  }

  const { products } = collection.node;
  //   Handpicked Array of returned collection of products
  let recommendedArray = [
    products[4],
    products[16],
    products[11],
    products[15],
  ];

  return <ProductCards products={recommendedArray} title={data.heading} />;
}

export const collectionProductsQuery = graphql`
  query {
    allShopifyCollection {
      edges {
        node {
          ...Collection
        }
      }
    }
  }
`;

export const collectionProductsFragment = graphql`
  fragment CollectionProductsListComponent on DatoCmsCollectionProductsList {
    id
    heading
    collectionHandle
    internal {
      type
    }
  }
`;
